import TemplateModel from "./TemplateModel";

export default class TemplateByIdModel extends TemplateModel {
  public labels: Record<string, string> = null;
  public customFields: Record<string, string> = null;
  public adContent: string = null;
}
